const { connect } = require('react-redux')
const SuperAgent = require('superagent')
const store = require('../')
const defaultAuthenticationConfig = require('../../config/authentication/uk')
const defaultLoginConfig = require('../../config/navigation/login/uk')
const Tracker = require('../../../_plugins/lib/tracker.js')
const Helpers = require('../../../_plugins/lib/helpers.js')
const Config = require('../../../config/generatedConfig')

const mapStateToProps = state => {
  return {
    loggedInData: state.loggedInData
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const { loggedInData = {} } = store
  const getLoginAuthConfig = () => {
    return ownProps.authenticationConfig || defaultAuthenticationConfig
  }
  const getLoginConfig = () => {
    return typeof ownProps.loginConfig === 'object' ? ownProps.loginConfig : defaultLoginConfig
  }
  const onUserLogin = data => {
    const { bookingHistory = {} } = loggedInData
    const { isFetching, isReady, hasError } = bookingHistory
    dispatch({
      type: 'LOGIN',
      data
    })
    if (!isFetching && !isReady && !hasError) {
      dispatch({
        type: 'BOOKING_HISTORY_READY',
        data: data.bookings
      })
    }
  }
  const userLogout = () => {
    const { auth } = getLoginAuthConfig()
    SuperAgent
      .get(auth.logout)
      .withCredentials()
      .end(userLogoutResponse)
  }
  const userLogoutResponse = () => {
    dispatch({
      type: 'LOGOUT'
    })
  }
  const successfulLogin = res => {
    const data = res.body
    if (!data.email) return
    Tracker.inline('login_successful', '1')
    data.validUser = true
    const settings = ownProps.settings || Config.settings
    Helpers.setCookie('Email', data.email, false, settings.cookieDomain)
    Helpers.setCookie('email', data.email, false, settings.cookieDomain)
    if (data.address && data.address.user_id) {
      Helpers.setCookie('customerID', data.address.user_id, false, settings.cookieDomain)
    }
    if (data.vehicle && data.vehicle.user_id) {
      Helpers.setCookie('customerID', data.vehicle.user_id, false, settings.cookieDomain)
    }
    Tracker.inline('logged_in_status', 'authenticated')
    if (window && window.$) {
      $(':input[type=email].emailAddress').val(data.email)
    }
    onUserLogin(data)
  }
  const failedLogin = reportFailedLogin => {
    const emailExists = loginGetEmailCookie()
    const captureValue = emailExists !== '' ? 'recognised' : 'new_user'
    Tracker.inline('logged_in_status', captureValue)
    validateTripappUser(emailExists)
    if (reportFailedLogin) {
      Tracker.inline('login_failed', '1')
      dispatch({
        type: 'LOGIN_FAILED',
        data: true
      })
    }
  }
  const userLoggedInResponse = (err, res) => {
    if (err || res.status === 404) return failedLogin(false)
    successfulLogin(res)
  }
  const userLoginRequest = callback => {
    const { auth } = getLoginAuthConfig()
    try {
      SuperAgent
        .get(auth.url)
        .withCredentials()
        .end(callback)
    } catch (e) {
      // return false;
    }
  }
  const userLogin = () => {
    userLoginRequest(userLoggedInResponse)
  }
  const validatedTripappUser = (err, res) => {
    const prefix = ownProps.trackingPrefix ? ownProps.trackingPrefix : ''
    if (err || res.status === 404 || !res.body) return Tracker.inline(prefix + 'not_valid_user_email', '1')
    Tracker.inline(prefix + (res.body.exists ? 'valid_user_email' : 'not_valid_user_email'), '1')
    dispatch({
      type: 'VALID_USER',
      data: res.body.exists === true
    })
  }
  const validateTripappUser = email => {
    if (!email) return
    const { userExists } = getLoginAuthConfig()
    try {
      SuperAgent
        .get(userExists.url + '?email=' + email.replace('+', '%2b') + '&token=' + userExists.token)
        .end(validatedTripappUser)
    } catch (error) {
      // console.log( error );
    }
  }
  const loginGetEmailCookie = () => {
    return Helpers.getCookie('email') || Helpers.getCookie('Email') || ''
  }
  const invalidUser = () => {
    dispatch({
      type: 'INVALID_USER'
    })
  }

  return {
    invalidUser,
    userLogout,
    userLogin,
    userLogoutResponse,
    getLoginConfig,
    getLoginAuthConfig,
    loginGetEmailCookie
  }
}

const connectedComponent = (WrappedComponent) => connect(
  mapStateToProps,
  mapDispatchToProps
)(WrappedComponent)

module.exports = connectedComponent
